import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";

import { ERROR_TYPE, translateError } from "@/utils";
import "react-quill/dist/quill.snow.css";

interface IRichTextEditorProps {
	className?: string;
	value?: string;
	setValue?: (value: string) => void;
	placeholder?: string;
	errorMessage?: string;
}

export default function RichTextEditor({
	className,
	value,
	setValue,
	placeholder,
	errorMessage,
}: IRichTextEditorProps) {
	const [editorContent, setEditorContent] = useState<string>(value ?? "");
	const isFirstRender = useRef(true);

	const handleChange = (value: string) => {
		setEditorContent(value);
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;

			return;
		}

		if (setValue && editorContent !== value) {
			setValue(editorContent);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [editorContent]);

	return (
		<div className={`markdown-editor relative ${className}`}>
			<div className="editor-container">
				<ReactQuill
					modules={{
						toolbar: [
							["bold", "italic", "strike"],
							[{ list: "ordered" }, { list: "bullet" }],
							[{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
							["clean"],
						],
					}}
					placeholder={placeholder ?? ""}
					style={{ minHeight: "196px", maxHeight: "196px" }}
					value={editorContent}
					onChange={handleChange}
				/>
			</div>
			{errorMessage && (
				<p className="absolute -bottom-6 text-[12px] text-danger">
					{translateError[errorMessage as unknown as ERROR_TYPE] ?? errorMessage}
				</p>
			)}
		</div>
	);
}
